import { useState } from "react";

interface Props {
  onSubmit: (masterPassword: string) => Promise<void>;
  onFaceId?: () => Promise<void>;
  faceIdEnrolled: boolean;
}

export function Unlock({ onSubmit, onFaceId, faceIdEnrolled }: Props) {
  // Show the Face ID button as the primary action when a credential is enrolled;
  // the master password form is still reachable via a small link below.
  const [mode, setMode] = useState<"faceid" | "password">(
    faceIdEnrolled ? "faceid" : "password",
  );
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submitPassword(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const pwCopy = pw;
    setPw("");
    try {
      await onSubmit(pwCopy);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function triggerFaceId() {
    if (!onFaceId) return;
    setError(null);
    setBusy(true);
    try {
      await onFaceId();
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="center-screen">
      <div className="brand">
        <img src="icon.svg" alt="" width={72} height={72} />
        <h1>Sejf</h1>
        <div className="sub">Odblokuj, aby zobaczyć hasła</div>
      </div>

      {mode === "faceid" && faceIdEnrolled ? (
        <>
          <button
            type="button"
            className="btn-block"
            onClick={triggerFaceId}
            disabled={busy}
            style={{ marginBottom: 12 }}
          >
            {busy ? "Czekam na Face ID…" : "Odblokuj Face ID"}
          </button>

          {error && <div className="error">{error}</div>}

          <button
            type="button"
            className="secondary btn-block"
            onClick={() => {
              setError(null);
              setMode("password");
            }}
            style={{ marginTop: 4 }}
          >
            Użyj hasła głównego
          </button>
        </>
      ) : (
        <form onSubmit={submitPassword}>
          <div className="field">
            <label htmlFor="pw">Hasło główne</label>
            <input
              id="pw"
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              autoComplete="current-password"
              autoFocus
              required
              enterKeyHint="go"
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button
            type="submit"
            className="btn-block"
            disabled={busy || pw.length === 0}
          >
            {busy ? "Odblokowuję…" : "Odblokuj"}
          </button>

          {faceIdEnrolled && (
            <button
              type="button"
              className="secondary btn-block"
              onClick={() => {
                setError(null);
                setMode("faceid");
              }}
              style={{ marginTop: 8 }}
            >
              Wróć do Face ID
            </button>
          )}
        </form>
      )}
    </div>
  );
}
